







import { expandPath } from "@/api/helpers";
import { MediaItem } from "@/api/models";
import { Component, Prop, Vue } from "vue-property-decorator";
import { notEmptyString } from "../../api/validators";

@Component({
  components: {},
  filters: {},
})
export default class PdfFrame extends Vue {
  @Prop({ default: () => new MediaItem() }) mediaItem: MediaItem;
  @Prop({ default: () => "Download" }) downloadLabel: string;

 /*  get pdfViewerEnabled() {
    if (navigator instanceof Navigator) {
      const isSafari = (ua) => /Safari\/\d/.test(ua) && !/Chrom(e|ium)\//.test(ua);

      return isSafari(navigator.userAgent) || undefined !== navigator?.pdfViewerEnabled;
    } else {
      return false;
    }
  } */

  get showPdfInline() {
    return this.filename.endsWith('.pdf');
  }

  get downloadMsg() {
    return [this.downloadLabel, this.altRef].join(': ');
  }

  get matchedSource() {
    return notEmptyString(this.mediaItem.source, 2)? this.mediaItem.source : 'local';
  }

  get filename() {
    return this.mediaItem.filename;
  }

  get figureClasses() {
    return ['pdf-container'];
  }

  get altRef() {
    return this.mediaItem.title;
  }

  get filePath() {
    switch (this.mediaItem.source) {
      case "cloudinary":
        return this.filename;
      default:
        return expandPath(this.filename)
    }
  }
}
